import { DisplayInfoProps } from "../../atoms/DisplayInfo/interface";

export enum OnboardingScreens {
  REGISTRATION = "REGISTRATION",
  CONTRACT = "CONTRACT",
  TDS = "TDS",
  LIVE = "LIVE",
}

export enum StepsStatus {
  wait = "wait",
  process = "process",
  finish = "finish",
}

export enum StepsKey {
  STAGE_1 = "STAGE_1",
  STAGE_2 = "STAGE_2",
  STAGE_3 = "STAGE_3",
}

export interface StepsInfo {
  [stage: string]: {
    status: StepsStatus;
    header: string;
    title: string;
    widgets?: DisplayInfoProps[];
    isDisabled?: boolean;
  };
}
